<template>
<div>
  <OrganicHeader v-if="tenantLoginType === 'organic'"></OrganicHeader>
  <VasHeader v-if="tenantLoginType === 'vas'"></VasHeader>
</div>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import { userInfo } from 'os'
import LogoutFrom from '@/components/LogoutForm'
import OrganicHeader from '@/components/OrganicHeader'
import VasHeader from '@/components/VasHeader'

export default {
  name: 'Header',
  components:{
    LogoutFrom,
    OrganicHeader,
    VasHeader
  },
  computed: {
    ...mapGetters({
      tenantDesignConfig: 'tenantDesign/config',
    }),
    tenantLoginType () {
      return this.tenantDesignConfig.userManagement.loginType.toLowerCase()
    },
  },
}
</script>
